import { useTranslation } from "react-i18next"

import type { CategorizedCitation } from "../../utils/citation-categorizer"
import type { Document } from "@/api/models"

import { M365Icon } from "@/features/ai-explorer/components/m365-icon"

import { M365CitationItem } from "../m365-citation-item"

type M365SourcesSectionProps = {
  sources: CategorizedCitation[]
  documents: [string, Document][]
  onNavigateToInline: (index: number) => void
  highlightedIndex: number | null
  messageIndex?: number
}

export function M365SourcesSection({
  sources,
  documents,
  onNavigateToInline,
  highlightedIndex,
  messageIndex,
}: M365SourcesSectionProps) {
  const { t } = useTranslation()

  if (sources.length === 0) return null

  return (
    <div className="space-y-2">
      <h4 className="text-muted-foreground flex items-center gap-2 text-sm font-semibold">
        <M365Icon noText />
        <span>
          {t("answer.m365_sources")} ({sources.length})
        </span>
      </h4>
      <div className="grid grid-cols-1 gap-2">
        {sources.map(({ citation, index }) => (
          <M365CitationItem
            key={index}
            citation={citation}
            documents={documents}
            index={index}
            isHighlighted={highlightedIndex === index}
            messageIndex={messageIndex}
            onNavigateToInline={onNavigateToInline}
          />
        ))}
      </div>
    </div>
  )
}
